//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      topTiles: [
        {
          title: '首页',
          path: '/measurement/home'
        },
        {
          title: '平台载体',
          path: '/measurement/carrier'
        },
        {
          title: '基础设施',
          path: '/measurement/baseSheshi'
        },
        {
          title: '研究成果',
          path: '/measurement/chengguo'
        },
        {
          title: '成功案例',
          path: '/measurement/anli'
        },
        {
          title: '专家人才',
          path: '/measurement/expert'
        },
        {
          title: '计量活动',
          path: '/overall/home'
        },
        {
          title: '资讯公告',
          path: '/measurement/news1'
        },
        {
          title: '政策法规',
          path: '/measurement/news2'
        }
      ],
      activeIndex: ''
    }
  },

  watch: {
    '$route'(to, from) {
      console.log('路由变化了！', from.path, '->', to.path)
      for (let i = 0; i < this.topTiles.length; i++) {
        const item = this.topTiles[i]
        if (to.path.indexOf(item.path) !== -1) {
          this.activeIndex = item.path
          break
        }
      }
    }
  },

  components: {},

  computed: {},

  mounted() {
    this.activeIndex = this.$route.path
  },

  methods: {
    activeTab(item) {
      this.activeIndex = item.path
      this.goPages(item.path)
    },
    goPages(url) {
      this.$router.push({
        path: url
      })
    },
  }
}
